import { defaultApiState } from '../api.state';

export const widgetMutations = {
  GET_WIDGETS_LOADING(state) {
    state.apiState.getMutations = {
      ...defaultApiState,
      loading: true,
    };
  },
  GET_WIDGETS_SUCCESS(state, payload) {
    state.apiState.getMutations = {
      ...defaultApiState,
      success: true,
    };
    state.widgets = payload;
  },
  GET_WIDGETS_ERROR(state, error) {
    state.apiState.getMutations = {
      ...defaultApiState,
      error,
    };
  },

  ADD_WIDGET_LOADING(state) {
    state.apiState.addWidget = {
      ...defaultApiState,
      loading: true,
    };
  },
  ADD_WIDGET_SUCCESS(state) {
    state.apiState.addWidget = {
      ...defaultApiState,
      success: true,
    };
  },
  ADD_WIDGET_ERROR(state, error) {
    state.apiState.addWidget = {
      ...defaultApiState,
      error,
    };
  },

  GET_WIDGET_RESET(state) {
    state.apiState.getWidget = {
      ...defaultApiState,
    };
    state.widget = undefined;
  },
  GET_WIDGET_LOADING(state) {
    state.apiState.getWidget = {
      ...defaultApiState,
      loading: true,
    };
  },
  GET_WIDGET_SUCCESS(state, payload) {
    state.apiState.getWidget = {
      ...defaultApiState,
      success: true,
    };
    state.widget = payload;
  },
  GET_WIDGET_ERROR(state, error) {
    state.apiState.getWidget = {
      ...defaultApiState,
      error,
    };
  },

  UPDATE_WIDGET_LOADING(state) {
    state.apiState.updateWidget = {
      ...defaultApiState,
      loading: true,
    };
  },
  UPDATE_WIDGET_SUCCESS(state) {
    state.apiState.updateWidget = {
      ...defaultApiState,
      success: true,
    };
  },
  UPDATE_WIDGET_ERROR(state, error) {
    state.apiState.updateWidget = {
      ...defaultApiState,
      error,
    };
  },

  DELETE_WIDGET_LOADING(state) {
    state.apiState.deleteWidget = {
      ...defaultApiState,
      loading: true,
    };
  },
  DELETE_WIDGET_SUCCESS(state, payload) {
    state.apiState.deleteWidget = {
      ...defaultApiState,
      success: true,
    };
    state.widgets = state.widgets.filter(o => o.id !== payload.id);
  },
  DELETE_WIDGET_ERROR(state, error) {
    state.apiState.deleteWidget = {
      ...defaultApiState,
      error,
    };
  },
  UPDATE_WIDGET_SEQUENCE_LOADING(state) {
    state.apiState.updateSequence = {
      ...defaultApiState,
      loading: true,
    };
  },
  UPDATE_WIDGET_SEQUENCE_SUCCESS(state) {
    state.apiState.updateSequence = {
      success: true,
    };
  },
  UPDATE_WIDGET_SEQUENCE_ERROR(state, error) {
    state.apiState.updateSequence = {
      ...defaultApiState,
      error,
    };
  },
};
